import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CloseFilterSVG from 'component/svgComponents/close'
import Form from 'component/commonReport/Form'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import moment from 'moment'

class QueryLogsSideFilterForm extends Component {
  static propTypes = {
    submit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    setSideFilterVisible: PropTypes.func.isRequired,
    handleFilter: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    showSideFilter: PropTypes.bool.isRequired,
    user: PropTypes.object,
    functionalityOptions: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      resetKey: 0
    }
  }

  get formFields() {
    const { translate, initialValues, user, functionalityOptions } = this.props
    const { resetKey } = this.state
    const isReset = resetKey > 0
    const [dtStart, dtEnd] = isReset ? [false, false] : (initialValues?.dtPeriod || [false, false])

    return [
      {
        type: 'branchs_without_multselect',
        name: 'idBranch',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        attrs: {
          withoutRegions: true
        },
        required: !user.isLdapInManager,
        initial: isReset ? (!user.isLdapInManager ? user.locationCode.padStart(4, '0') : '') : (initialValues?.idBranch || '')
      },
      {
        type: 'select',
        name: 'functionality',
        label: translate('query.logs.modal.functionality'),
        help_text: translate('query.logs.functionality.new'),
        options: functionalityOptions,
        required: true,
        initial: isReset ? '' : (initialValues?.functionality || ''),
        attrs: {
          initialValue: isReset ? null : (initialValues?.functionality 
            ? functionalityOptions.find(option => option.value === initialValues.functionality)
            : null)
        }
      },
      {
        type: 'input',
        name: 'listId',
        label: translate('lm_label'),
        help_text: translate('query.logs.listId.new'),
        initial: isReset ? '' : (initialValues?.listId || ''),
        attrs: {
          maxLength: 8,
          mask: '99999999'
        }
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
        attrs: {
          maxRange: null,
          initialValue: isReset ? null : (dtStart && dtEnd ? [moment(dtStart), moment(dtEnd)] : null)
        },
        initial: isReset ? [] : (initialValues?.dtPeriod || [])
      },
      {
        type: 'hour_range',
        name: 'hrPeriod',
        help_text: '00:00',
        initial: isReset ? ['', ''] : (initialValues?.hrPeriod || ['', ''])
      },
    ]
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showSideFilter && !this.props.showSideFilter) {
      this.setState({ resetKey: 0 })
    }
    
    if (this.props.showSideFilter) {
      setTimeout(() => {
        const resetButton = document.querySelector('#report-form .btn-danger-outline')
        if (resetButton) {
          resetButton.onclick = (e) => {
            e.preventDefault()
            e.stopPropagation()
            this.setState(prevState => ({ resetKey: prevState.resetKey + 1 }))
          }
        }
      }, 200)
    }
  }

  render() {
    const { translate, setSideFilterVisible, handleFilter, showSideFilter, initialValues } = this.props
    const { resetKey } = this.state
    const formKey = showSideFilter 
      ? `filter-${initialValues?.idBranch || ''}-${initialValues?.functionality || ''}-${initialValues?.listId || ''}-${resetKey}`
      : 'closed'

    return (
      <div className={`common-report no-margin no-padding h-0`}>
        <div className='content'>
          <div
            className={`filters-overlay ${showSideFilter ? 'show' : ''}`}
          />
          <div
            className={`filters fixed ${showSideFilter ? 'open' : ''}`}
          >
            <div className='close' onClick={setSideFilterVisible}>
              <CloseFilterSVG />
            </div>
            <h2>{translate('commonReport.filters')}</h2>
            <Form
              key={formKey}
              fields={this.formFields}
              onSubmit={(values) => handleFilter(values)}
              translate={translate}
              cleanFilters={true}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user
})

const QueryLogsSideFilterFormTranslated = translate(null, { wait: true })(QueryLogsSideFilterForm)

export default connect(mapStateToProps)(QueryLogsSideFilterFormTranslated)

export { QueryLogsSideFilterForm }
